import React from 'react';
import styled from 'styled-components';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { CurrentConditionsHeader } from './currentConditionsHeader/currentConditionsHeader';
import { CurrentConditionsBody } from './currentConditionsBody/currentConditionsBody';

export const CurrentConditionsWidget = () =>
{
    return (
        <CurrentConditionsWidgetContainer>
            <CurrentConditionsWrapper>
                <CurrentConditionsHeader/>
                <CurrentConditionsBody/>
            </CurrentConditionsWrapper>
        </CurrentConditionsWidgetContainer>
    );
};

CurrentConditionsWidget.displayName = 'CurrentConditionsWidget';

const CurrentConditionsWidgetContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 250px;
    width: 100%;
    @media ${smallMediaQuery} {
        height: 257px;
    }
`;

const CurrentConditionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 100%;
    padding: 10px;
    width: 257px;
    @media ${smallMediaQuery} {
        width: 344px;
    }
`;
